import React, { createContext, useContext, useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

const OptionsContext = createContext();
export const useOptions = () => useContext(OptionsContext);

export const OptionsProvider = ({ children }) => {
    const [dealStages, setDealStages] = useState([]);
    const [contactStages, setContactStages] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const [dealStagesData, contactStagesData] = await Promise.all([
                    supabase.from('deal_stages').select('nome').order('id'),
                    supabase.from('contact_stages').select('nome').order('id'),
                ]);
                if (dealStagesData.error) throw dealStagesData.error;
                if (contactStagesData.error) throw contactStagesData.error;

                // *** PONTO DE FALHA POTENCIAL ***
                // Se 'dealStagesData.data' for null, a linha abaixo falha
                setDealStages((dealStagesData.data || []).map(item => ({ value: item.nome, label: item.nome })));
                // Se 'contactStagesData.data' for null, a linha abaixo falha
                setContactStages((contactStagesData.data || []).map(item => ({ value: item.nome, label: item.nome })));

            } catch (error) {
                console.error("Erro ao buscar opções do Supabase:", error);
                
                // =================================================================
                // ALARME ADICIONADO AQUI
                // =================================================================
                alert('ERRO em OptionsContext [fetchOptions]: ' + error.message);

            } finally {
                setLoading(false);
            }
        };
        fetchOptions();
    }, []);

    const value = { dealStages, contactStages, loadingOptions: loading };
    return <OptionsContext.Provider value={value}>{children}</OptionsContext.Provider>;
};